<template>
	<div>
		<hero :content="heroContent" @hamburger="hamburgerClicked"></hero>
		<div class="clearfix">
			<voters class="voters col-xs-12"></voters>
		</div>
		<div class="clearfix topper">
		<critic-quote :criticSliderContent="criticSlider1" class="col-xs-12 no-pad"></critic-quote>
			<div class="col-xs-12 col-md-10 col-md-offset-1 video no-pad hideme">
				<video class="video-js vjs-default-skin" controls preload="none" data-setup='{"fluid": true}' poster="https://res.cloudinary.com/dwmmozjrb/image/upload/v1627840535/three-bb/video/best_director_01.jpg">
					<source src="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/best_director_01.mp4" type='video/mp4' />
					<source src="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/best_director_01.webm" type='video/webm' />
				</video>
			</div>
		</div>
		<div class="clearfix grid">
			<production-quote id="bestDirectorProdQuote1" class="col-xs-12 col-md-6 no-pad" :prodQuote="productionQuote1"></production-quote>
			<div class="col-xs-12 col-md-6 image hideme"><img src="https://res.cloudinary.com/dwmmozjrb/image/upload/v1627839187/three-bb/best_director_block_1.jpg" alt="Three Billboards Outside Ebbings, Missouri"></div>
			<production-quote id="bestDirectorProdQuote2" class="col-xs-12 no-pad" :prodQuote="productionQuote2"></production-quote>
		</div>
		<div class="clearfix grid">
			<div class="col-xs-12 col-md-6 image hideme"><img src="https://res.cloudinary.com/dwmmozjrb/image/upload/v1627839187/three-bb/best_director_block_2.jpg" alt="Three Billboards Outside Ebbings, Missouri"></div>
			<production-quote id="bestDirectorProdQuote3" class="col-xs-12 col-md-6 no-pad" :prodQuote="productionQuote3"></production-quote>
		</div>
		<div class="clearfix"></div>
		<click-thru :clickThru="clickThru" @clickThru="nextCategory"></click-thru>
		<social></social>
		<legal></legal>
	</div>
</template>
<script>
import Hero from '../../components/Hero';
import Voters from '../../components/Voters';
import CriticQuote from '../../components/CriticQuote';
import ProductionQuote from '../../components/ProductionQuote';
import ClickThru from '../../components/ClickThru';
import Social from '../../components/Social';
import Legal from '../../components/Legal';

export default {
	name: 'best-director',
	data: function() {
		return {
			heroContent: {
				"image": "best-director-3b-lg",
				"mobileImage": "best-director-3b-mob",
				"superHeader": "For Your Consideration",
				"header": "Best Director",
				"subHeader": ['MARTIN McDONAGH'],
				"isSubPage": true
			},
			clickThru: {
				superHeader: 'Next Category',
				mainText: 'Best Ensemble',
				clickThruPath: ''
			},
			criticSlider1: [
				{
					text: "&#9733; &#9733; &#9733; &#9733;<br />A renegade masterpiece. Martin McDonagh is an exhilarating gift to movies, a blunt-force artist with the soul of a poet.",
					author: '- ROLLING STONE'
				},
				{
					text: "A towering achievement. The best yet Martin McDonagh.",
					author: '- NY Post'
				},
				{
					text: "&#9733; &#9733; &#9733; &#9733;<br />This is the best movie I’ve seen this year. McDonagh has done a masterful job.",
					author: '- CHICAGO SUN-TIMES'
				},
			],
			productionQuote1: {
				text: "McDonagh’s styles is a form of magical realism, here mixed with a kind of Gothic Americana, based on the idea that people in small towns are not prosaic but poetic.",
				author: "Frances McDormand"
			},
			productionQuote2: {
				text: "The careful balance Martin brings between the funny and the serious is something magnificent. I guess it gets to the reason people sometimes laugh at funerals. In real life, opposing emotions often butt up against each other like that. When you suddenly experience humor after great tragedy, it’s a great kind of relief and I think it’s human nature to seek that. Martin can’t really help but be moving then hilarious then moving again because that’s the storyteller he is.",
				author: "Peter Dinklage"
			},
			productionQuote3: {
				text: "Martin doesn’t guess as a director. He's very specific. I think because Martin comes from theater he brings a different kind of vibe, where there’s more of a kinship and a communion with the actors.",
				author: "John Hawkes"
			}
		}
	},
	components: {
		Hero,
		Voters,
		CriticQuote,
		ProductionQuote,
		ClickThru,
		Social,
		Legal
	},
	methods: {
		hamburgerClicked: function() {
			console.log('hamburger passing through BestProduction');
			this.$emit('hamburger');
		},
		nextCategory: function() {
			console.log('nextCategory at categorypage');
			this.$emit('clickThru')
		}
	}
}
</script>


// WEBPACK FOOTER //
// BestDirector.vue?63777ff8